import { toast } from 'react-toastify'

import { api } from 'api'
import { Success } from 'constants/actionMessages'
import { UpdateConfigParams } from 'interfaces/store/config.interfaces'
import { createAsyncThunk } from 'modules/store'

export const getConfig = createAsyncThunk('config/get', async (_, { rejectWithValue }) =>
  api.config.get().catch((error) => rejectWithValue(error.message)),
)

export const updateConfig = createAsyncThunk('config/update', async (params: UpdateConfigParams, { rejectWithValue }) =>
  api.config
    .update(params.data)
    .then((data) => {
      if (params.onSuccess) {
        params.onSuccess()
      }
      toast.success(Success.Save)
      return data
    })
    .catch((error) => rejectWithValue(error.message)),
)
